import { appConfig } from '../../../../../constants/appConfig';
import axios from 'axios';
import httpHelper from '../../../../../utils/httpHelper';

const service = {
  async getReportJson(params, token) {
    const endPoint = 'reportJson';
    const result = await axios.get(`${appConfig.hpc}/${endPoint}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return result;
  },

  async getVehicleSafetyReport(params, token) {
    const endPoint = `kv/vehicle-safety-report/getReport`;
    const result = await axios.get(`${appConfig.hpc}/${endPoint}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return result;
  },

  async getReportingResponseByRequestId(params, token) {
    const endPoint = `rpt-responses/filter`;
    const result = await axios.get(`${appConfig.hpc}/${endPoint}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: params,
    });
    return result;
  },

  async getToken() {
    const endPoint = `/token`;
    const result = await httpHelper.makePostRequest(
      appConfig.tokenUrl,
      endPoint,
      {
        username: 'iok',
        password: '1',
      },
    );
    return result;
  },
};

export default service;
